import {
	getPreferenceInfo,
	setPreferenceInfo,
} from "apps/global_preferences/util/web";
import { createPreferenceLookup, getSaveableChange, updatePreferenceState } from "apps/global_preferences/util/helpers";

import { updateSentence } from "ducks/edit_wiw";

import _str from "shared/util/_str";


// Action types
// ----------------------------------------------------------------------------

export const TOGGLE_VISIBILITY = "GLOBAL_PREFERENCES.TOGGLE_VISIBILITY";

export const CLEAR_ERROR_MESSAGE = "GLOBAL_PREFERENCES.CLEAR_ERROR_MESSAGE";

export const GET_PREFERENCES = "GLOBAL_PREFERENCES.GET_PREFERENCES";
export const GET_PREFERENCES_SUCCESS = "GLOBAL_PREFERENCES.GET_PREFERENCES_SUCCESS";
export const GET_PREFERENCES_ERROR = "GLOBAL_PREFERENCES.GET_PREFERENCES_ERROR";

export const SET_PREFERENCES = "GLOBAL_PREFERENCES.SET_PREFERENCES";
export const SET_PREFERENCES_SUCCESS = "GLOBAL_PREFERENCES.SET_PREFERENCES_SUCCESS";
export const SET_PREFERENCES_ERROR = "GLOBAL_PREFERENCES.SET_PREFERENCES_ERROR";


// Initial State
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	preferences: {},
	categories: [],
	hasLiquidity: true,
	needsReboarding: false,
	error: { message: "" },
	isSaving: false,
	isLoading: true,
};


// Reducer
// ----------------------------------------------------------------------------

export function reducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_PREFERENCES: {
			return {
				...state,
				isLoading: true,
			};
		}

		case GET_PREFERENCES_SUCCESS: {
			return {
				...state,
				preferences: createPreferenceLookup(action.payload.data),
				categories: action.payload.data,
				needsReboarding: action.payload.needs_reboarding,
				isLoading: false,
			};
		}

		case GET_PREFERENCES_ERROR: {
			return {
				...state,
				error: action.payload.error,
				isLoading: false,
			};
		}

		case SET_PREFERENCES: {
			return {
				...state,
				isSaving: true,
				error: INITIAL_STATE.error,
			};
		}

		case SET_PREFERENCES_SUCCESS: {
			const { udpatedPreferenceId, updatedValues } = action.payload;
			return {
				...state,
				categories: action.payload.data,
				hasLiquidity: action.payload.hasLiquidity,
				isSaving: false,
				error: INITIAL_STATE.error,

				// update the preferences on the client side
				// the api response is not always up to date, so use the local changes
				// e.g. if you update distance and then use the data returned from the
				// successfrul update, the backend hasn't updated the value in time
				// so you'll see the old value unless you wait a second or two
				preferences: updatePreferenceState(udpatedPreferenceId, updatedValues, state.preferences),
			};
		}

		case SET_PREFERENCES_ERROR: {
			return {
				...state,
				error: action.payload.error,
				isSaving: false,
			};
		}

		default: {
			return state;
		}
	}
}


// Action creators
// ----------------------------------------------------------------------------

export function getPreferences() {
	return (dispatch) => {
		dispatch({ type: GET_PREFERENCES });

		getPreferenceInfo()
			.then((res) => {
				dispatch({ type: GET_PREFERENCES_SUCCESS, payload: res });
			}).catch((err) => {
				let errorMessage = _str("There was an error when trying to get your preferences");

				if (err.error && err.error.message) {
					errorMessage = _str(err.error.message);
				}

				// this is dumb, but otherwise getting the same error over and over
				// wouldn't result in a re-render, because the strings would be the same.
				// thanks, JS weirdness with deep equality
				const errorObject = { message: errorMessage };

				dispatch({ type: GET_PREFERENCES_ERROR, payload: { error: errorObject } });
			});
	};
}

export function setPreferences(modifiedPreference) {
	return (dispatch) => {
		dispatch({ type: SET_PREFERENCES });

		const preferenceId = modifiedPreference.id;
		const saveablePreferences = getSaveableChange(modifiedPreference);

		setPreferenceInfo(saveablePreferences)
			.then((res) => {
				if (res.wiwSentence) {
					dispatch(updateSentence(res.wiwSentence));
				}

				dispatch({
					type: SET_PREFERENCES_SUCCESS,
					payload: {
						...res,
						udpatedPreferenceId: preferenceId,
						updatedValues: saveablePreferences[preferenceId].values,
					},
				});
			}).catch((err) => {
				let errorMessage = _str("There was an error when trying to save your preferences");

				if (err.error && err.error.message) {
					errorMessage = _str(err.error.message);
				}

				const errorObject = { message: errorMessage };

				dispatch({ type: SET_PREFERENCES_ERROR, payload: { error: errorObject } });
			});
	};
}



// WEBPACK FOOTER //
// ./src/ducks/global_preferences.js